import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["pinField", "container"];

  togglePinField() {
    if (this.hasContainerTarget) {
      const selectElement = this.containerTarget.querySelector("select");
      if (!selectElement) return;

      const selectedOption = selectElement.options[selectElement.selectedIndex];
      if (!selectedOption) {
        this.clearPinField();
        return;
      }

      const validatePin = selectedOption.dataset.validate_pin === "true";

      if (validatePin) {
        this.pinFieldTarget.style.display = 'block';
        const pinInput = this.pinFieldTarget.querySelector('input');
        if (pinInput) {
          pinInput.setAttribute("required", "");
        }
      } else {
        this.clearPinField();
      }
    }
  }

  clearPinField() {
    this.pinFieldTarget.style.display = 'none';
    const pinInput = this.pinFieldTarget.querySelector('input');
    if (pinInput) {
      pinInput.removeAttribute("required");
      pinInput.value = '';
    }
  }
}
